import React from "react";
import { useMainPageStyles } from "./index.styles";

export default function MainPage() {
  const useStyles = useMainPageStyles();

  return <div className={useStyles.container}>MainPage</div>;
}
